import { MyLog } from "@common/common";
import { ensureArray, isJsObject, objectKeys, parseDec, to2Digits } from "./utils";
import { dateObjectFor, jsDayNames, numberToTime } from "./date-utils";

const NUM_WEEK_DAYS = 7;

function getDateFromPlannedDate(singleDate: any) {
  return new Date(singleDate.y, singleDate.m - 1, singleDate.d, 0, 0, 1);
}


function sortPlanDatesAsc(planDates: any[]) {
  planDates.sort((val: any, val2: any) => {
    return val.i - val2.i;
  });
}
function findNextEndOfWeek(end: any) {
  if (end instanceof Date) {
    let day = end.getDay();
    while (day !== 0) {
      end = dateObjectFor(end).add(1, 'days').toDate();
      day = end.getDay();
    }
    return end;
  }
  return end;
}
function findStartOfWeek(start: any) {
  if (start instanceof Date) {
    let day = start.getDay();
    while (day !== 1) {
      start = dateObjectFor(start).add(-1, 'days').toDate();
      day = start.getDay();
    }
    return start;
  }
  return start;
}


function dateToI(date: Date): number {
  return date.getFullYear() * 10000 + (date.getMonth() + 1) * 100 + date.getDate();
}

function createDummyEntry(date: Date): any {
  const y = date.getFullYear();
  const m = (date.getMonth() + 1);
  const day = date.getDate();
  //
  const dayI = y * 10000 + m * 100 + day;
  return {
    y: y,
    m: m,
    d: day,
    i: dayI,
    dates: []
  };
}

function getWeekNumber(searchDate: Date, yearStartDate: Date): number {
  let diff = searchDate.getTime() - yearStartDate.getTime();
  diff = diff / (24 * 60 * 60 * 1000);
  //console.log('DIFF:', diff, yearStartDate.toString(), searchDate.toString())
  return Math.ceil(diff / 7);
}

function createWeek(date: Date): any {
  const result: any = {};
  let rdow = date.getDay();
  let dow = rdow;
  if (dow === 0) {
    // dow = 6;
  }
  let ndow = (dow + 6) % 7;
  let curMoment = dateObjectFor(date);
  let dayOffset = 1;

  while (ndow > 0) {
    let prevDate: any = curMoment.subtract(dayOffset, 'days');
    ndow--;
    dayOffset++;
    prevDate = prevDate.toDate();
    let d = prevDate.getDay();
    let dn = jsDayNames[d];
    result[dn] = {
      dates: [],
      d: prevDate.getDate(),
      m: prevDate.getMonth() + 1,
      y: prevDate.getFullYear()
    };
  }

  ndow = (dow + 6) % 7;

  for (; ndow < 7; ndow++) {
    let d = curMoment.toDate();

    let cdow = d.getDay();
    let dn = jsDayNames[cdow];
    result[dn] = {
      dates: [],
      d: d.getDate(),
      m: d.getMonth() + 1,
      y: d.getFullYear()
    };

    curMoment = curMoment.add(1, 'days');
  }
  return result;
}

function entryToDayString(weekDay: any) {
  return [to2Digits(weekDay.d), to2Digits(weekDay.m), weekDay.y].join('.');
};

let __logDateSearch = false;
(window as any).logDateSearch = function (doLog: boolean) {
  __logDateSearch = doLog;
};

(window as any).doDateTests = function () {
  test_findWeekRanges();
};
/**
 *
 * @param dates list of dates
 * @param start start filter date
 * @param end end filter date
 * @param startAtStartDate whether to start at start filter date
 * @returns
 */
export function createCalendarWeeks(
  dates: any[],
  start: any,
  end: any,
  startAtStartDate: boolean
) {
  let years: any = {};
  let linearDates: any[] = [],
    curDay: any,
    allW: any[] = [],
    allW2: any[] = [];
  const firstDay = 1, invalidDates: any[] = [], usedDayNames: any[] = [];
  //test_findWeekRanges();

  for (let idx = 0; idx < NUM_WEEK_DAYS; idx++) {
    let dnIdx = (idx + firstDay) % NUM_WEEK_DAYS;
    usedDayNames.push(jsDayNames[dnIdx]);
  }

  createCalendarWeeksInput(dates, linearDates, invalidDates, end);
  invalidDates.length && MyLog.error('Invalid dates:', invalidDates);

  if (!(end instanceof Date)) {
    end = new Date();
  }

  sortPlanDatesAsc(linearDates);
  const endOfWeekForEnd = findNextEndOfWeek(end);
  //console.log('END/EOW:', end, endOfWeekForEnd);

  if (!(start instanceof Date)) {
    start = new Date();
  }
  const startOfWeekForStart = findStartOfWeek(start);
  //console.log('START/SOW:', start, startOfWeekForStart);

  linearDates = extendDatesTillEnd(endOfWeekForEnd, linearDates);
  linearDates = extendDatesTillStart(startOfWeekForStart, linearDates);

  sortPlanDatesAsc(linearDates);
  let curWeek: any = { values: {} }, started = false;
  //console.log('LD', linearDates.slice());

  for (let idx = 0; idx < linearDates.length; idx++) {
    let curPlanDate = linearDates[idx];
    const curDate = getDateFromPlannedDate(curPlanDate);
    const curDay = curDate.getDay();
    const weekDay = jsDayNames[curDay];

    if (started) {
      curWeek.values[weekDay] = curPlanDate
      curWeek.days++;
    } else {
      if (curDay === 1) {
        curWeek.values[weekDay] = curPlanDate
        curWeek.days = 1;
        started = true;
      }
    }
    if (7 === curWeek.days) {
      allW2.push(curWeek.values);
      curWeek = {
        days: 0,
        values: {}
      };
    }
  }

  allW2.forEach((item: any) => {
    for (let k in item) {
      setWeekDayName(item[k]);
    }
  });

  return {
    weeks: allW2,
    firstDay,
    dayNames: usedDayNames,
  };
  /*
    setupYears(linearDates, years);

    tryPrependTillStartDay(startOfWeekForStart, startAtStartDate, linearDates, years);

    linearDates.length = 0;

    const yearKeys = objectKeys(years).map((y: any) => {
      return parseInt('' + y, 10);
    });

    yearKeys.sort();

    let currentDate = new Date();
    const cY = currentDate.getFullYear();
    const cM = currentDate.getMonth() + 1;
    const cD = currentDate.getDate();

    console.log('YEARS:', years);

    for (let k of yearKeys) {
      const days = years[k].days;
      const weeks: any[] = years[k].weeks;

      let dayIdx = 0;

      for (; dayIdx < days.length; dayIdx++) {
        curDay = days[dayIdx];
        const curDate = getDateFromPlannedDate(curDay);
        curDate.setMinutes(30);
        const curYearDate = new Date(curDay.y, 0, 1, 0, 0, 1);
        let curWeekIdx = getWeekNumber(curDate, curYearDate);
        if (curWeekIdx > 0) {
          curWeekIdx--;
        }

        if (curDay.y === cY && curDay.m === cM && curDay.d === cD) {
          curDay.current = true;
        }

        if (!weeks[curWeekIdx]) {
          const w = createWeek(curDate);
          console.log('NW:', curWeekIdx, w);
          weeks[curWeekIdx] = w;
        }

        let weekDay: number | string = curDate.getDay();
        let dnIdx = weekDay;
        weekDay = jsDayNames[dnIdx as number];
        weeks[curWeekIdx][weekDay] = curDay;
      }

      console.log('YEARS:', years);

      let lastYearKey = yearKeys[0];

      // Merge weeks
      for (let yearIdx = 0; yearIdx < yearKeys.length; yearIdx++) {

        let yearToCheck = yearKeys[yearIdx];
        let yearEntries = years[yearToCheck];

        //
        if (yearKeys.length > 1 && yearIdx < yearKeys.length - 1) {
          const curYearDate = new Date(yearToCheck, 0, 1, 0, 0, 1);
          const curDate = new Date(yearToCheck, 11, 31, 0, 0, 1);
          let curWeekIdx = getWeekNumber(curDate, curYearDate);

          if (curWeekIdx > 0) {
            curWeekIdx--;
          }
          if (!yearEntries.weeks[curWeekIdx]) {
            yearEntries.weeks[curWeekIdx] = createWeek(curDate);
          }
          console.log('Last week:', curWeekIdx);
        }

        let weekIdx = 0;
        let hasWeek = false;
        let cd: any;

        if (yearToCheck === lastYearKey) {
          let lastSkip = 0;
          for (; weekIdx < yearEntries.weeks.length; weekIdx++) {
            let curWeek = yearEntries.weeks[weekIdx];
            if (!hasWeek) {
              console.log('Check:', curWeek)
              hasWeek = objectKeys(curWeek).length > 0;
              if (hasWeek) {
                for (let k in curWeek) {
                  if (jsDayNames.indexOf(k) >= 0) {
                    cd = curWeek[k];
                    break;
                  }
                }
                if (cd) {
                  cd = new Date(cd.y, cd.m - 1, cd.d, 0, 0, 1);
                }
              }
            }
            if (hasWeek) {
              if (!curWeek) {
                //console.log('DUMMY WEEKS:', weekIdx);
                curWeek = createWeek(cd);
              }
              //console.log('AW:O:', weekIdx, yearToCheck, curWeek);
              allW.push(curWeek);
              cd = dateObjectFor(cd).add(7, 'days').toDate();
            } else {
              lastSkip = weekIdx;
            }
          }
          //console.log('Last skip:', lastSkip);
        } else {
          const lyk = parseInt('' + lastYearKey, 10);
          const prevDate = new Date(lyk, 11, 31, 0, 0, 1);
          const doMerge = prevDate.getDay() !== 0;
          if (doMerge) {
            console.log('Merge weeks!');
            let firstWeekEntries = yearEntries.weeks[0];
            if (firstWeekEntries) {
              let lastWeek = allW[allW.length - 1];
              for (let dayKey in firstWeekEntries) {
                lastWeek[dayKey] = firstWeekEntries[dayKey];
                cd = lastWeek[dayKey];
              }
              hasWeek = true;
            }
            weekIdx = 1;

          }
          for (; weekIdx < yearEntries.weeks.length; weekIdx++) {
            let curWeek = yearEntries.weeks[weekIdx];
            if (!hasWeek) {
              hasWeek = objectKeys(curWeek).length > 0;
              if (hasWeek) {
                for (let k in curWeek) {
                  if (jsDayNames.indexOf(k) >= 0) {
                    cd = curWeek[k];
                    break;
                  }
                }
                if (cd) {
                  cd = new Date(cd.y, cd.m - 1, cd.d, 0, 0, 1);

                }
              }
            }
            if (hasWeek) {
              if (!curWeek) {
                //console.log('DUMMY WEEKS:NEW:', weekIdx);
                curWeek = createWeek(cd);
              }
              //console.log('AW:M:', curWeek);
              allW.push(curWeek);
              cd = dateObjectFor(cd).add(7, 'days').toDate();
            }
          }
          lastYearKey = yearToCheck;
        }
      }
    }

    // Some bug (can't find), remove duplicates
    let lastI = 0, removed = false;
    for (let curI = 1; curI < allW.length; curI++) {
      if (allW[lastI] === allW[curI]) {
        allW[curI] = null;
        removed = true;
      } else {
        lastI = curI;
      }
    }
    if (removed) {
      //console.log('REM:FIRST!');
      allW = allW.filter((e: any) => {
        return !!e;
      })
    }

    years = {};

    allW.forEach((item: any) => {
      for (let k in item) {
        setWeekDayName(item[k]);
      }
    });

    console.log('A1:', allW);
    console.log('A2:', allW2);

    return {
      weeks: allW,
      firstDay,
      dayNames: usedDayNames,
    };
    */
}
function setWeekDayName(weekDay: any) {
  if (weekDay.y) {
    weekDay.date = entryToDayString(weekDay);
  }
}

function createCalendarWeeksInput(
  dates: any[],
  linearDates: any[],
  invalidDates: any[],
  end: any
) {
  let year, month, day;
  let skippedDates: any[] = [];
  let endMoment: any = end ? dateObjectFor(end) : null;

  for (let singleDate of dates) {
    if (
      isJsObject(singleDate) &&
      singleDate.y &&
      singleDate.m &&
      singleDate.d
    ) {
      year = parseDec('' + singleDate.y);
      month = parseDec('' + singleDate.m);
      day = parseDec('' + singleDate.d);

      if (isNaN(year) || isNaN(month) || isNaN(day)) {
        invalidDates.push(singleDate);
        continue;
      }
      const dateToCheck = new Date();
      dateToCheck.setFullYear(year, month - 1, day);

      if (endMoment && (endMoment.isSame(dateToCheck, 'days') || endMoment.isBefore(dateToCheck, 'days'))) {
        skippedDates.push(singleDate);
        continue;
      }

      if (!singleDate.dummy) {
        ensureArray(singleDate.dates).forEach((item: any) => {
          const order = item.order;
          const customer = order?.customer;
          if (customer && !customer.name) {
            customer.name = customer.first_name + ' ' + customer.last_name;
          }
          if (order) {
            if (!item.from && order.work_from) {
              item.from = numberToTime(order.work_from);
            }
            if (!item.to && order.work_to) {
              item.to = numberToTime(order.work_to);
            }
          }
        });
      }

      singleDate.i = year * 10000 + month * 100 + day;

      linearDates.push(singleDate);
    }
  }

  skippedDates.length > 0 && MyLog.log('SKIPPED:END:', skippedDates);
}

function extendDatesTillEnd(end: any, linearDates: any[]) {
  let res = linearDates;

  if (end && end instanceof Date) {
    const endI = dateToI(end);
    linearDates = linearDates.slice();
    //
    let ldl = linearDates.length, e: any, idx = 0, existing: any = {};
    if (ldl > 0) {
      sortPlanDatesAsc(linearDates);
    } else {
      linearDates.push(createDummyEntry(end));
      ldl++;
    }

    //Cut off end
    while (ldl > 0 && linearDates[ldl - 1].i > endI) {
      ldl--;
    }

    linearDates.length = ldl;

    if (!ldl) {
      linearDates.push(createDummyEntry(end));
      ldl = 1;
    }

    while (idx < ldl) {
      e = linearDates[idx];
      existing[e.i] = e;
      idx++;
    }
    let current = linearDates[0];
    let nd = getDateFromPlannedDate(current), currentI = current.i;

    while (currentI <= endI) {
      if (!existing[currentI]) {
        e = createDummyEntry(nd);
        linearDates.push(e);
        __logDateSearch && console.log('ADD:E:', currentI, e);
      }
      nd = dateObjectFor(nd).add(1, 'days').toDate();
      currentI = dateToI(nd);
    }

    sortPlanDatesAsc(linearDates);

    idx = 0;
    ldl = linearDates.length;

    while (idx < ldl && linearDates[idx].i <= endI) {
      idx++;
    }
    linearDates.length = idx;
    __logDateSearch && console.log('Cut:', idx, ldl);
    return linearDates;
  }
  return res;
}

function extendDatesTillStart(start: any, linearDates: any[]) {
  let res = linearDates, idx = 0, existing: any = {};
  if (start && start instanceof Date) {
    const startI = dateToI(start);
    res = [];
    //
    let ldl = linearDates.length;
    if (ldl > 0) {
      sortPlanDatesAsc(linearDates);
    } else {
      res.push(createDummyEntry(start));
      ldl++;
    }

    //Cut off end
    while (ldl > 0 && linearDates[ldl - 1].i >= startI) {
      let e = linearDates[ldl - 1];
      existing[e.i] = e;
      res.push(e);
      ldl--;
    }

    if (!res.length) {
      res.push(createDummyEntry(start));
    }

    let e: any, current = res[0];
    let nd = getDateFromPlannedDate(current),
      currentI = current.i,
      prepend: any[] = [];

    while (currentI >= startI) {
      if (!existing[currentI]) {
        e = createDummyEntry(nd);
        prepend.push(e);
        __logDateSearch && console.log('ADD:S:', currentI, e);
      }
      nd = dateObjectFor(nd).add(-1, 'days').toDate();
      currentI = dateToI(nd);
    }
    res = res.concat(prepend)

    sortPlanDatesAsc(res);

    ldl = res.length;
    idx = ldl;

    linearDates = res;
    res = [];

    while (ldl > 0 && linearDates[ldl - 1].i >= startI) {
      let e = linearDates[ldl - 1];
      res.push(e);
      ldl--;
    }
    sortPlanDatesAsc(res);
    ldl = res.length;

    __logDateSearch && console.log('Cut:', idx, ldl);
  }
  return res;
}


function tryPrependTillStartDay(
  start: any,
  startAtStartDate: boolean,
  linearDates: any[],
  years: any
) {
  let yearS, filled = false;

  const startYear = start ? start.getFullYear() : null;

  // Try to prepend days
  for (let curDate of linearDates) {
    yearS = curDate.y + '';

    if (startAtStartDate) {
      if (startYear && '' + startYear === yearS && !filled) {
        let dayAdd = 1;
        let res = dateObjectFor(start);
        let cm = getDateFromPlannedDate(curDate);
        let curMoment = dateObjectFor(cm);

        while (curMoment.isAfter(res, 'days')) {
          const rd = res.toDate();
          years[yearS].days.push(createDummyEntry(rd));
          //res = moment(start).add(dayAdd, 'd');
          res = dateObjectFor(start).add(dayAdd, 'd');
          dayAdd++;
        }
        filled = true;
      }
    }

    years[yearS].days.push(curDate);
  }
  return filled;
}


function setupYears(linearDates: any[], years: any) {
  linearDates.forEach((curDate: any) => {
    var yearS = curDate.y + '';

    if (!years[yearS]) {
      years[yearS] = {
        days: [],
        weeks: []
      };
    }
  });
}

function test_findWeekRanges() {
  const allTestCases: any[] = [
    [
      [2024, 7, 8],
      [2024, 7, 9],
      [2024, 7, 10],
      [2024, 7, 11],
      [2024, 7, 12],
      [2024, 7, 13],
      [2024, 7, 14],
    ],
    [
      [2022, 12, 26],
      [2022, 12, 27],
      [2022, 12, 28],
      [2022, 12, 29],
      [2022, 12, 30],
      [2022, 12, 31],
      [2023, 1, 1],
    ]
  ];
  function arrToDate(d: any[]) {
    return new Date(d[0], d[1] - 1, d[2], 0, 0, 1);
  };

  for (let testCases of allTestCases) {
    let fd = testCases[0], ld = testCases[6];
    let expected = arrToDate(ld),
      expectedStart = arrToDate(fd);

    let failedDates: any[] = [], failedStartDates: any[] = [];

    for (let d of testCases) {
      let td = arrToDate(d);
      let eow = findNextEndOfWeek(td);
      if (dateToI(eow) !== dateToI(expected)) {
        failedDates.push(td);
      }
      eow = findStartOfWeek(td);
      if (dateToI(eow) !== dateToI(expectedStart)) {
        failedStartDates.push(td);
      }
    }

    console.log('(START)', expectedStart, 'Failed:', failedStartDates);
    console.log('(END)', expected, 'Failed:', failedDates);
  }
}
